
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reports/industry/[groupedIndustryId]",
      function () {
        return require("private-next-pages/reports/industry/[groupedIndustryId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reports/industry/[groupedIndustryId]"])
      });
    }
  